module.exports = __webpack_public_path__ + "static/img/avatar_8.183c08c.png";


//////////////////
// WEBPACK FOOTER
// ./static/avatars/avatar_8.png
// module id = 1599
// module chunks = 61